import { useAtomValue } from 'jotai'
import type { MunicipalityMinimalSingle } from '@/types'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import { selectedMunicipalityIdAtom } from '@/state'
import { useMunicipality } from '@/hooks/api/use-municipality'

interface MunicipalityLoaderProps {
    children: (data: MunicipalityMinimalSingle) => React.ReactNode
}

const MunicipalityLoader: React.FC<MunicipalityLoaderProps> = ({
    children,
}) => {

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    const { status, data, error } = useMunicipality(municipalityId)

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={'Nepovedlo se načíst zvolenou obec.'}
        />
    }


    return <>{children(data)}</>
}

export default MunicipalityLoader
